import { useNavigate } from "react-router-dom";

import {
 
  FaPhoneAlt,
 
} from "react-icons/fa";
import logoImg from "../Images/logo.jpeg";
import image1 from"../Images/image1.jpeg"
import image2 from"../Images/image2.jpeg"
import image3 from"../Images/image3.jpeg"
import image4 from"../Images/image4.jpeg"
import image5 from"../Images/image5.jpeg"
import image6 from"../Images/image6.jpeg"
function Footer() {
  const navigate = useNavigate();

  return (
    <>
      {/* MAIN FOOTER */}
      <footer className="footer-main">
        <div className="container-fluid">
          <div className="row">

            {/* FOOTER CONTENT */}
            <div className="col-lg-10 mx-auto">
              <div className="container py-5">
                <div className="row gy-4">

                  {/* Logo & About */}
                  <div className="col-lg-4 col-md-6">
                    <div className="bg-white p-3 rounded-2 col-md-8 text-center">
                 <img
                   src={logoImg}
                   alt="Baba Industries Logo"
                   className="navbar-brand"
                   style={{
                     height: "120px",
                     cursor: "pointer",
                     objectFit: "contain",
                        borderRadius: "10%",
                   }}
                   
                 />
                 </div>

                    <div className="d-flex align-items-center mt-4">
                      <div className="icon-circle me-3">
                        <FaPhoneAlt className="me-4fs-5" />
                      </div>
                      <div>
                        <p className="mb-1">+9415481386 </p>
                        <p className="mb-0">+8318992308</p>
                      </div>
                    </div>
                  </div>
{/* Quick Links */}
<div className="col-lg-2 col-md-6">
  <h5 className="footer-title">Quick Links</h5>

  <ul className="footer-links ms-3">
    <li style={{ cursor: "pointer" }} onClick={() => navigate("/")}>
      Home
    </li>

    <li style={{ cursor: "pointer" }} onClick={() => navigate("/about")}>
      About Us
    </li>

    <li style={{ cursor: "pointer" }} onClick={() => navigate("/range")}>
      Our Products
    </li>

    <li style={{ cursor: "pointer" }} onClick={() => navigate("/contact")}>
      Contact
    </li>
  </ul>
</div>


                  {/* Photo Gallery */}
         <div className="col-lg-3 col-md-6 ps-lg-5">

                    <h5 className="footer-title text-center">Photo Gallery</h5>

                    <div className="footer-gallery">
                      {[
                        image1,
                        image2,
                        image3,
                        image4,
                        image5,
                        image6,
                      ].map((img, i) => (
                        <img src={img} alt="gallery" key={i} />
                      ))}
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </footer>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <div className="container d-flex justify-content-between align-items-center flex-wrap gap-3">
          <p className="mb-0">
            Copyright © HF Haydra. All Rights Reserved. Developed By <span style={{cursor:'pointer '}} onClick={() => window.open('https://dectwinservices.com', '_blank')}>Dectwin Services Pvt Ltd</span>
          </p>

          {/* <div className="footer-bottom-links">
            <span>Setting & Privacy</span>
            <span>FAQ</span>
            <span>Support</span>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default Footer;
